export default {"src":"/_next/static/media/DNA.efb310ff.svg","height":18,"width":18};